<template>
  <div class="app-page-title">
    <Row>
      <h2 class="app-page-title__heading">{{pageTitle}}</h2>
      <Breadcrumb class="app-page-title__breadcrumb" v-if="breadcrumb.length > 1">
        <BreadcrumbItem to="/">首页</BreadcrumbItem>
        <BreadcrumbItem v-for="(item, index) in breadcrumb" :key="index" :to="item.path || ''">
          {{ item.name }}
        </BreadcrumbItem>
      </Breadcrumb>
    </Row>
  </div>
</template>
<script>
export default {
  name: 'AppPageTitle',
  computed: {
    breadcrumb () {
      return this.$store.getters.breadcrumb
    },
    pageTitle () {
      const bLength = this.breadcrumb.length
      return bLength ? this.breadcrumb[bLength - 1].name : ''
    }
  }
}
</script>
<style lang="less">
  @import '../../assets/less/base/variables.less';
  .app-page-title {
    padding: 16px 24px;
    background: #fff;
    border-bottom: 1px solid @box-border-inner-color;
    margin: 0 -24px;
    &__heading {
      font-size: 20px;
    }
    &__breadcrumb {
      font-size: 13px;
      margin: 8px 0;
      line-height: 1;
      transition: all @animation-time;
      a {
        color: @subsidiary-color ;
      }
    }
  }
</style>
